import { render, staticRenderFns } from "./ApiLookupExampleDataModal.vue?vue&type=template&id=d54d6052&scoped=true&"
import script from "./ApiLookupExampleDataModal.vue?vue&type=script&lang=js&"
export * from "./ApiLookupExampleDataModal.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupExampleDataModal.vue?vue&type=style&index=0&id=d54d6052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54d6052",
  null
  
)

export default component.exports